module.exports = __webpack_public_path__ + "img/3.8c6ba1e9.png";